// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2B5uI","title":"FrontImage_title__1Wjr8"};